import { takeEvery } from "redux-saga/effects";
import { GET_BUYER_IDENTITY } from "../../state/buyer-identity/constants";
import getBuyerIdentity from "./get-buyer-identity";

function* buyerIdentity() {
  yield takeEvery(GET_BUYER_IDENTITY, getBuyerIdentity);
}

export default buyerIdentity;
